$( document ).on('click', '.custom-select-list .custom-select-el', function(event){
  let target = $(event.target).closest('.custom-select-el');
  let custom_select = target.closest('.custom-select');
  let value = target.attr('data-custom-select-value');
  change_custom_select(custom_select, value);
});

window.change_custom_select = function(custom_select, value){
  let select = custom_select.find('.custom-select-input');
  select.val(value);
  select.trigger('change');
  custom_select.find('.custom-select-list .custom-select-el').attr('data-custom-select-hidden', false);
  let selected_el = custom_select.find(`.custom-select-list .custom-select-el[data-custom-select-value="${value}"]`),
      selectMenu = selected_el.closest(".custom-select-menu");

  if (!selectMenu.data("need-remove-item")) {
    custom_select.find('.custom-select-list .custom-select-el').removeClass("selected");
    selected_el.addClass("selected");
  } else {
    selected_el.attr('data-custom-select-hidden', true);
  }

  let toggleWrapper = custom_select.find('.custom-select-toggle-wrapper');
  toggleWrapper.html(selected_el.html());
  if (toggleWrapper.hasClass('placeholder')) {
    toggleWrapper.removeClass('placeholder');
  }
  close_dropdown(custom_select);
};

export default function () {}
